<table [dataSource]="items" mat-table class="condensed" (paste)="onPaste($event)">
  <ng-container matColumnDef="name">
    <th *matHeaderCellDef mat-header-cell>Bindingstid</th>
    <td *matCellDef="let interest;" mat-cell>
      {{ interest.product | binding }}
    </td>
  </ng-container>

  @for (l of ltvs; track $index) {
    <ng-container [matColumnDef]="l">
      <th *matHeaderCellDef mat-header-cell
          style="padding: 0 12px 0 0;white-space: nowrap; text-align: center">
        <!-- First and last columns are special -->
        <div style="font-weight: normal">{{ l }}</div>
        <div>
          @if (l === '50') {
            0 - 50 %
          } @else if (l === '100') {
            90 - 100+ %
          } @else {
            {{ +l - 5 }} - {{ l }}%
          }
        </div>
      </th>
      <td *matCellDef="let row;" mat-cell style="padding: 0 4px 0 0">
        <!-- see component for an explanation -->
        <spb-interest-input [value]="{p: row.interests[l]}"/>
      </td>
    </ng-container>
  }

  <tr *matHeaderRowDef="columns()" mat-header-row style="font-weight: bold"></tr>
  <tr *matRowDef="let row; columns: columns()" mat-row></tr>
</table>